import ParsingMessage from "./parsing-message";

/* Class for storing parsing errors */
class ParsingWarning extends ParsingMessage{
    constructor(position: number, message: string) {
        super(position, message, "warning");
    }
}

export default ParsingWarning;
